/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListFeeRevenueGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListFeeRevenueRequest = {
  skip?: number | undefined;
  count?: number | undefined;
  /**
   * The Partner's AccountID.
   */
  accountID: string;
  /**
   * Optional transfer ID to filter the results by.
   */
  transferID?: string | undefined;
  /**
   * Optional dispute ID to filter the results by.
   */
  disputeID?: string | undefined;
  /**
   * Optional residual ID to filter the results by.
   */
  residualID?: string | undefined;
  /**
   * Optional date-time to inclusively filter all fees created after this date-time.
   */
  startDateTime?: string | undefined;
  /**
   * Optional date-time to exclusively filter all fees created before this date-time.
   */
  endDateTime?: string | undefined;
};

export type ListFeeRevenueResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.IncurredFee>;
};

/** @internal */
export const ListFeeRevenueGlobals$inboundSchema: z.ZodType<
  ListFeeRevenueGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListFeeRevenueGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListFeeRevenueGlobals$outboundSchema: z.ZodType<
  ListFeeRevenueGlobals$Outbound,
  z.ZodTypeDef,
  ListFeeRevenueGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listFeeRevenueGlobalsToJSON(
  listFeeRevenueGlobals: ListFeeRevenueGlobals,
): string {
  return JSON.stringify(
    ListFeeRevenueGlobals$outboundSchema.parse(listFeeRevenueGlobals),
  );
}
export function listFeeRevenueGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListFeeRevenueGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFeeRevenueGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFeeRevenueGlobals' from JSON`,
  );
}

/** @internal */
export const ListFeeRevenueRequest$inboundSchema: z.ZodType<
  ListFeeRevenueRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  accountID: z.string(),
  transferID: z.string().optional(),
  disputeID: z.string().optional(),
  residualID: z.string().optional(),
  startDateTime: z.string().optional(),
  endDateTime: z.string().optional(),
});
/** @internal */
export type ListFeeRevenueRequest$Outbound = {
  skip?: number | undefined;
  count?: number | undefined;
  accountID: string;
  transferID?: string | undefined;
  disputeID?: string | undefined;
  residualID?: string | undefined;
  startDateTime?: string | undefined;
  endDateTime?: string | undefined;
};

/** @internal */
export const ListFeeRevenueRequest$outboundSchema: z.ZodType<
  ListFeeRevenueRequest$Outbound,
  z.ZodTypeDef,
  ListFeeRevenueRequest
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  accountID: z.string(),
  transferID: z.string().optional(),
  disputeID: z.string().optional(),
  residualID: z.string().optional(),
  startDateTime: z.string().optional(),
  endDateTime: z.string().optional(),
});

export function listFeeRevenueRequestToJSON(
  listFeeRevenueRequest: ListFeeRevenueRequest,
): string {
  return JSON.stringify(
    ListFeeRevenueRequest$outboundSchema.parse(listFeeRevenueRequest),
  );
}
export function listFeeRevenueRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListFeeRevenueRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFeeRevenueRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFeeRevenueRequest' from JSON`,
  );
}

/** @internal */
export const ListFeeRevenueResponse$inboundSchema: z.ZodType<
  ListFeeRevenueResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.IncurredFee$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListFeeRevenueResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.IncurredFee$Outbound>;
};

/** @internal */
export const ListFeeRevenueResponse$outboundSchema: z.ZodType<
  ListFeeRevenueResponse$Outbound,
  z.ZodTypeDef,
  ListFeeRevenueResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.IncurredFee$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listFeeRevenueResponseToJSON(
  listFeeRevenueResponse: ListFeeRevenueResponse,
): string {
  return JSON.stringify(
    ListFeeRevenueResponse$outboundSchema.parse(listFeeRevenueResponse),
  );
}
export function listFeeRevenueResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListFeeRevenueResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFeeRevenueResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFeeRevenueResponse' from JSON`,
  );
}
